import { createAction, props } from "@ngrx/store";
import { ICreateRevisionStatusRequest, ICreateRevisionStatusResponse, IGetRevisionStatusResponse, IUpdateRevisionStatusRequest, IUpdateRevisionStatusResponse } from "src/app/revisions/models/revision-status";

// Get Revision Status
export const getRevisionStatus = createAction(
    '[Revision Status] Get Revision Status'
);

export const getRevisionStatusSuccess = createAction(
    '[Revision Status] Get Revision Status success', 
    props<{ revisionStatus: IGetRevisionStatusResponse[] }>()
);

export const getRevisionStatusFailure = createAction(
    '[Revision Status] Get Revision Status failure',
    props<{error: string}>()
);

// Get Revision Status by id
export const getRevisionStatusById = createAction(
    '[Revision Status] Get Revision Status by id ',
    props<{id: string}>()
);

export const getRevisionStatusByIdSuccess = createAction(
    '[Revision Status] Get Revision Status by id success', 
    props<{ revisionStatus: IGetRevisionStatusResponse }>()
);

export const getRevisionStatusByIdFailure = createAction(
    '[Revision Status] Get Revision Status by id failure',
    props<{error: string}>()
);

// Create Revision Status
export const createRevisionStatus = createAction(
    '[Revision Status] Create Revision Status',
    props<{ revisionStatus: ICreateRevisionStatusRequest }>()
);

export const createRevisionStatusSuccess = createAction(
    '[Revision Status] Create Revision Status success',
    props<{ revisionStatus: ICreateRevisionStatusResponse }>()
);

export const createRevisionStatusFailure = createAction(
    '[Revision Status] Create Revision Status failure',
    props<{error: string}>()
);

// Update Revision
export const updateRevisionStatus = createAction(
    '[Revision Status] Update Revision Status',
    props<{ revisionStatus: IUpdateRevisionStatusRequest }>()
);

export const updateRevisionStatusSuccess = createAction(
    '[Revision Status] Update Revision Status success',
    props<{ revisionStatus: IUpdateRevisionStatusResponse }>()
);

export const updateRevisionStatusFailure = createAction(
    '[Revision Status] Update Revision Status failure',
    props<{error: string}>()
);

// Delete Revision Status
export const deleteRevisionStatus = createAction(
    '[Revision Status] Delete Revision Status',
    props<{id: string}>()
);

export const deleteRevisionStatusSuccess = createAction(
    '[Revision Status] Delete Revision Status success',
    props<{id: string}>()
);

export const deleteRevisionStatusFailure = createAction(
    '[Revision Status] Delete Revision Status failure',
    props<{error: any }>()
);